<template>
  <div id="AccountData">
    <Navbar :fixed="true" :title="$route.query.subtype ? $t('转账记录') : $t('账户记录')" />
    <van-tabs v-model="active" @click="handleTabs" color="var(--theme)" title-inactive-color="var(--gray1)"
      title-active-color="var(--theme)">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item.title">
        <div class="tabs-item">
          <div class="list-item app_card" v-for="(items, index) in newList" :key="index">
            <div class="list-item_head">
              <div class="list-item-left">
                <p class="list-item-title">{{ items.title }}</p>
                <template v-if="items.setting.direction
                ">
                  <template v-if="items.setting.direction == 'out'">
                    <p class="list_item_money">{{ $t('转入') }}：{{ items.setting.counterparty_userid }}</p>
                  </template>
                  <template v-if="items.setting.direction == 'in'">
                    <p class="list_item_money">
                      {{ $t('转出') }}：{{ items.setting.counterparty_userid }}
                    </p>
                  </template>
                </template>
              </div>
              <div class="list-item-right">
                <span v-if="items.setup <= 0" class="list-item-money-green">{{
                  items.setup
                }}</span>
                <span v-else class="list-item-money">+{{ items.setup }}</span>
                <!-- language-ch 余额 -->
                <span class="list-item-after">{{ $t("newAdd.Balance") }}：{{ items.after }}</span>
              </div>
            </div>
            <div class="list_item_reamrk" v-if="items.setting.remark">
              {{ $t('备注说明') }}：{{ items.setting.remark }}
            </div>
            <div class="list-item-indate">{{ $format(items.indate) }}</div>
          </div>
        </div>
      </van-tab>
      <!-- <div class="tabs-item"></div> -->
      <!-- 底部分页的东西 -->
      <div class="bottom-content">
        <div class="Text">
          {{ $t("newAdd.Total") }} {{ Paging.Total }}
          {{ $t("newAdd.records") }}, {{ $t("newAdd.DisplayPerPage") }}
          {{ Paging.PageSize }}{{ $t("newAdd.NullNum") }},
          {{ $t("newAdd.total") }} {{ Paging.Num ? Paging.Num : 1 }}
          {{ $t("newAdd.pages") }}
        </div>
        <van-pagination prev-text="<" next-text=">" v-model="Paging.CurrentPage" mode="simple"
          :total-items="Paging.Total" :items-per-page="Paging.PageSize" @change="PageEvent" />
      </div>
    </van-tabs>
  </div>
</template>

<script>
import { countTime, getMyTime, deciTurnMoney, formatDate } from "@/utils/tools";
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Tab,
  Tabs,
  Image,
  NoticeBar,
  Field,
  DropdownMenu,
  DropdownItem,
  Popup,
  DatetimePicker,
  Pagination,
  Toast,
} from "vant";
import { REQUEST_API } from "@/http/api";
import { GET_MONEY_LIST } from "@/api";
import { getTimeStamp } from "@/utils/tools";
import Navbar from "@/components/JNav";

export default {
  name: "AccountData",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Image.name]: Image,
    [NoticeBar.name]: NoticeBar,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Pagination.name]: Pagination,
    Navbar,
  },
  data() {
    return {
      show: false, // 控制日期按钮弹出框的
      // 日期选择的值
      TimeOne: "",
      TimeTwo: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 12, 31),
      currentDate: new Date(),
      type: "", // 控制当前时间点击状态为哪一个
      active: 0, // 标签选中的值
      tabList: [
        {
          // title: this.$t('My.PersonalInformation.AccountData.Semua'),
          title: this.$t("newAdd.all"),
        },
        {
          // title: this.$t('My.PersonalInformation.AccountData.Penarikan'),
          title: this.$t("newAdd.Income"),
        },
        {
          // title: this.$t('My.PersonalInformation.AccountData.IsiUlang'),
          title: this.$t("newAdd.Expenditure"),
        },
      ],
      // 分页的数据
      Paging: {
        PageSize: 10, // 当前一页多少条
        CurrentPage: 1, // 当前页
        Num: "", // 分页的数量
        Total: 0, // 总条数
      },
      list: [],
      pageNo: 1,
      lists: [],
    };
  },
  computed: {
    newList() {
      /**
       * <= 1待审核
       * 2成功
       */
      let list = this.lists.map((_) => ({
        ..._,
        stateTxt:
          _.status <= 1 ? this.$t("newAdd.toAudit") : this.$t("newAdd.succeed"),
        amount: deciTurnMoney(_.amount),
      }));
      return list;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    PageEvent() {
      this.list = [];
      this.getList();
    },
    handleTabs(name, title) {
      this.list = [];
      this.Paging.CurrentPage = 1;
      this.getList();
    },
    getList() {
      let form = {
        type: "money",
        setup: this.active,
        page: this.Paging.CurrentPage,
        subtype: this.$route.query.subtype || "0",
      };
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      GET_MONEY_LIST(form).then((r) => {
        Toast.clear();
        if (r.data.ret === 1) {
          const { lastPage, currentPage, perPage, total } = r.data.data
          this.Paging = {
            pageSize: perPage,
            CurrentPage: currentPage,
            Num: lastPage,
            Total: total
          }
          Toast.clear();
          let dataLists = r.data.data.lists;
          if (r.data.data.currentPage > 1) {
            for (let i = 0; i < dataLists.length; i++) {
              this.lists.push(dataLists[i]);
            }
          } else {
            this.lists = dataLists;
          }
        } else {
          Toast.clear();
          // this.$toast(r.data.msg);
        }
      }).catch((e) => {
        Toast.clear();
      });
    },
  },
};
</script>

<style lang="less" scoped>
#AccountData {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  // background: var(--bg);
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  @Color: var(--theme);
  @comRadius: 10px;
  @comBG: linear-gradient(#093958, #022c47);
  @wrapPadding: calc(12rem / 16);

  /deep/ .van-tabs__wrap {
    .van-tabs__nav {
      background: var(--bg2)
    }
  }

  .tabs-item {
    padding: 10px;
    display: grid;
    gap: 10px;
  }

  .van-tabs {
    .van-tabs__wrap {
      border-bottom: 1px solid #eee;
    }
  }

  .bottom-content {
    margin: 0 10px;
    background-color: var(--bg1);
    border-radius: 10px;
    overflow: hidden;

    >.Text {
      width: 100%;
      text-align: center;
      line-height: 1.25rem;
      // color: #666;
      color: var(--gray1);
      font-size: 0.75rem;
    }
  }

  .header {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.625rem 0;

    .Text {
      margin: 0 0.625rem;
      font-size: 0.875rem;
    }

    >.button-Time {
      display: block;
      text-align: center;
      width: 6.5rem;
      height: 1.875rem;
      line-height: 1.875rem;
      border-radius: 0.9375rem;
      font-size: 0.875rem;
      background: #f2f2f2;
    }

    >.van-button {
      height: 1.875rem;
      width: 5rem;
      border-radius: 0.9375rem;
      color: var(--textColor);
      background: #ff7614;
    }

    // 标签栏的
  }
}

.list-item {
  padding: calc(14rem / 16);
  border-radius: 12px;

  .list-item_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .list-item-left {
      flex: 1;

      .list-item-title {
        flex: 1;
        font-size: calc(14rem / 16);
        color: #0f172A;
        font-weight: 600;
      }

      .list_item_money {
        font-size: 14px;
        color: #0f172A;
        font-weight: 600;
        margin-top: 3px;
      }
    }

    .list-item-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .list-item-money,
      .list-item-money-green {
        padding-left: calc(6rem / 16);
        font-size: calc(17rem / 16);
        color: #dc1323;
      }

      .list-item-money-green {
        color: #1bb019;
      }

      .list-item-after {
        margin-top: calc(3rem / 16);
        font-size: calc(11rem / 16);
        line-height: calc(17rem / 16);
        padding-left: calc(6rem / 16);
        color: var(--gray1);
      }
    }
  }

  .list_item_reamrk {
    margin: 9px 0 0;
    padding: 8px 10px;
    border-radius: 12px;
    background: #ffb24d1f;
    color: #9a5d00;
    font-size: 12px;
    font-weight: 800;
  }

  .list-item-indate {
    margin-top: calc(6rem / 16);
    font-size: calc(12rem / 16);
    // color: #888888;
    color: var(--gray1);
  }
}
</style>